import { State } from '@weave/schema-gen-ts/dist/schemas/platform-location-feature/v1/platform-enums/location_feature_enum.pb';
import { Feature } from '@weave/schema-gen-ts/dist/shared/feature/location_feature.pb';
import { useAppFlagStore } from './use-feature-flag';

export const AIR_INTEGRATION_CUSTOMIZATION_FEATURE_ENUM = Feature.WEAVE_AIR_INTEGRATION;

const ACTIVE_STATES = [State.ACTIVE, State.PROMOTE];

export const useAIRIntegrationCustomizationFlag = (locationIds: string[]) => {
  const { getCustomizationFlagLocationMap } = useAppFlagStore();

  const flagMap = getCustomizationFlagLocationMap({
    locationIds,
    featureEnum: AIR_INTEGRATION_CUSTOMIZATION_FEATURE_ENUM,
  });

  const hasWeaveAIRIntegrationAccess = locationIds.some((id) =>
    ACTIVE_STATES.includes(flagMap[id]?.state ?? State.HIDE)
  );

  return { hasWeaveAIRIntegrationAccess };
};
